import { Button, FormField, FormGrid, Page } from '@dixa/lib-shared-habla';
import { formValueSelector, InjectedFormProps, reduxForm } from 'redux-form';

import { useBreakpointValue } from 'utils/mediaQuery';
import { useAppSelector } from 'utils/redux/useAppSelector';

import { GeneralSettings } from './components/generalSettings/generalSettings';
import { LastAgentSettings } from './components/lastAgentSettings/lastAgentSettings';
import { OfferSettings } from './components/offerSettings/offerSettings';
import { PreferredAgentSettings } from './components/preferredAgentSettings/preferredAgentSettings';
import type { FormValues } from './types/settings';
import { validateQueuesSettingsForm } from './utils/validateQueueSettingsForm';

export type Props = {
  mode?: 'create' | 'edit';
  isLoading?: boolean;
};

const formFields = [
  'name',
  'priority',
  'is_default',
  'is_archived',
  'offer_timeout',
  'wrapup_timeout',
  'offer_algorithm',
  'is_do_not_offer_enabled',
  'offer_abandoned_conversations',
  'is_preferred_agent_enabled',
  'is_personal_offer_prioritized',
  'do_not_offer_timeouts',
  'preferred_agent_timeouts',
  'preferred_agent_offline_timeout_enabled',
  'preferred_agent_offline_timeout',
  'personal_agent_offline_timeout_enabled',
  'personal_agent_offline_timeout',
];

const queuesSettingsForm = 'queuesSettingsForm';

function QueuesSettingsFormImpl({
  pristine,
  submitting,
  handleSubmit,
  mode,
  isLoading,
}: InjectedFormProps<FormValues> & Props): JSX.Element {
  const formValues = useAppSelector((state) =>
    formValueSelector(queuesSettingsForm)(state, ...formFields),
  );

  const isMediumScreen = useBreakpointValue({ base: true, lg: false });
  const span = isMediumScreen ? 6 : 4;

  return (
    <form onSubmit={handleSubmit} id="queue-settings-form">
      <Page.Section
        title="General"
        controls={
          <Button
            disabled={pristine || submitting || isLoading}
            isLoading={isLoading}
            type="submit"
          >
            {mode === 'edit' ? 'Save changes' : 'Create queue'}
          </Button>
        }
      >
        <FormGrid>
          <FormField span={span}>
            <GeneralSettings formValues={formValues} />
          </FormField>

          <FormField span={span}>
            <OfferSettings formValues={formValues} />
          </FormField>

          <FormField span={span}>
            <LastAgentSettings formValues={formValues} />
          </FormField>

          <FormField span={span}>
            <PreferredAgentSettings formValues={formValues} />
          </FormField>
        </FormGrid>
      </Page.Section>
    </form>
  );
}

export const QueuesSettingsForm = reduxForm<FormValues, Props>({
  form: queuesSettingsForm,
  enableReinitialize: true,
  validate: validateQueuesSettingsForm,
})(QueuesSettingsFormImpl);
